import uz from './uz.json';
import ru from './ru.json';
import en from './en.json';
import { useAuthStore, type Language } from '@/stores/auth.store';

type Dict = Record<string, string>;
const dicts: Record<Language, Dict> = { uz, ru, en };

export function translate(
  lang: Language,
  key: string,
  params: Record<string, string | number> = {},
): string {
  const dict = dicts[lang] ?? dicts.uz;
  let s = dict[key] ?? dicts.uz[key] ?? key;
  for (const [k, v] of Object.entries(params)) {
    s = s.replaceAll(`{{${k}}}`, String(v));
  }
  return s;
}

/** Hook returning a translator tied to the current language in the store. */
export function useT() {
  const lang = useAuthStore((s) => s.language);
  return (key: string, params?: Record<string, string | number>) =>
    translate(lang, key, params ?? {});
}

/**
 * Picks the localized field from an object that follows the {prefix}{Lang}
 * convention (e.g. nameUz / nameRu / nameEn). Loose `object` constraint
 * keeps it callable on every entity (Product, Category, …) without forcing
 * each to extend Record<string, unknown>.
 */
export function pickLocalized(
  obj: object,
  prefix: string,
  lang: Language,
): string {
  const k = `${prefix}${lang.charAt(0).toUpperCase()}${lang.slice(1)}`;
  return ((obj as Record<string, unknown>)[k] as string) ?? '';
}
